import {
  CyberKitPath,
  CyberKitComplianceManagementPath,
} from "../AppModuleConfig";

const CyberKitComplianceManagementNavigation = [
  // {
  //   key: "privacykit-compliant-management-dashboard",
  //   path: `${PrivacyKitPath}${PrivacyKitCompliantManagementPath}/dashboard`,
  //   title: "แดชบอร์ด",
  //   breadcrumb: false,
  //   icon: null,
  //   submenu: [],
  // },
  {
    key: "privacykit-compliant-management-assessment",
    path: `${CyberKitPath}${CyberKitComplianceManagementPath}/compliance-cyberkit/assessment`,
    title: "การกำหนดแบบประเมิน",
    breadcrumb: false,
    icon: null,
    submenu: [],
  },
  {
    key: "privacykit-compliant-management-report",
    path: `${CyberKitPath}${CyberKitComplianceManagementPath}/compliance-cyberkit/report`,
    title: "ประมวลผลแบบประเมินและมอบหมายงาน",
    breadcrumb: false,
    icon: null,
    submenu: [],
  },
  // {
  //   key: "privacykit-compliant-management-plan",
  //   path: `${PrivacyKitPath}${PrivacyKitCompliantManagementPath}/plan`,
  //   title: "แผนบริหารจัดการ",
  //   breadcrumb: false,
  //   icon: null,
  //   submenu: [],
  // },
  {
    key: "privacykit-compliant-management-tak",
    path: `${CyberKitPath}${CyberKitComplianceManagementPath}/compliance-cyberkit/task`,
    title: "การติดตามงานที่มอบหมาย",
    breadcrumb: false,
    icon: null,
    submenu: [],
  },
];

export default CyberKitComplianceManagementNavigation;
